export const getArrayWithoutEmptyStrings = (array) => {
  return array.filter(elem => elem !== '')
}
